import { useState, useEffect, useCallback } from 'react'
import useSetlists from '../hooks/useSetlists'
import SetlistBrowse from '../components/SetlistBrowse'
import SetlistEditor from '../components/SetlistEditor'

function isUpcoming(setlist) {
  return new Date(setlist.date) >= new Date(new Date().toDateString())
}

function SetlistsSection({ onLabelChange, onActionsChange, onPresent }) {
  const { setlists, saveSetlist } = useSetlists()
  const [view, setView]               = useState('browse')
  const [browseMode, setBrowseMode]   = useState('upcoming')
  const [activeSetlist, setActiveSetlist] = useState(null)

  const filtered = setlists.filter(s =>
    browseMode === 'upcoming' ? isUpcoming(s) : !isUpcoming(s)
  )

  useEffect(() => {
    if (view === 'browse') onLabelChange('Setlists')
    return () => onLabelChange('Setlists')
  }, [view, onLabelChange])

  useEffect(() => {
    if (view === 'browse') {
      onActionsChange([{
        label: browseMode === 'upcoming' ? 'View past setlists' : 'View upcoming',
        onClick: () => setBrowseMode(m => m === 'upcoming' ? 'past' : 'upcoming')
      }])
    } else {
      onActionsChange([
        {
          label: 'Discard & Return',
          onClick: () => {
            setView('browse')
            setActiveSetlist(null)
            onLabelChange('Setlists')
          }
        },
        {
          label: 'Save',
          onClick: () => {
            const el = document.querySelector('[data-testid="editor-state"]')
            if (el) {
              const state = JSON.parse(el.getAttribute('data-state'))
              saveSetlist(state)
            }
            setView('browse')
            setActiveSetlist(null)
            onLabelChange('Setlists')
          }
        },
        {
          label: 'Present',
          onClick: () => {
            const el = document.querySelector('[data-testid="editor-state"]')
            if (el) {
              const state = JSON.parse(el.getAttribute('data-state'))
              saveSetlist(state)
              onPresent(state)
            }
          }
        }
      ])
    }
    return () => onActionsChange([])
  }, [view, browseMode, onActionsChange, onLabelChange, saveSetlist, onPresent])

  const handleNew = useCallback(() => {
    setActiveSetlist({ title: '', date: '', songs: [] })
    setView('editor')
  }, [])

  const handleOpen = useCallback((setlist) => {
    setActiveSetlist(setlist)
    setView('editor')
  }, [])

  const handleLabelChange = useCallback((label) => {
    onLabelChange(label)
  }, [onLabelChange])

  if (view === 'editor' && activeSetlist) {
    return (
      <SetlistEditor
        setlist={activeSetlist}
        onSave={(s) => { saveSetlist(s); setView('browse') }}
        onDiscard={() => setView('browse')}
        onLabelChange={handleLabelChange}
        onPresent={onPresent}
      />
    )
  }

  return (
    <SetlistBrowse
      setlists={filtered}
      onNew={handleNew}
      onOpen={handleOpen}
      onPresent={onPresent}
      browseMode={browseMode}
    />
  )
}

export default SetlistsSection
